














import {
  Component,
  Vue,
  Prop,
} from "vue-property-decorator";

@Component
export default class Pane extends Vue {
  @Prop() public data: object;
}
